export default __webpack_public_path__ + "static/media/black-wallpaper-4.def360bf.jpg";